/* Trappbutiken – innehållsförteckning + sticky sidokolumn (Wubs).
 *
 * DELAS av `wubs-article` (bloggen) och `wubs-page` (sidmallen). Allt hängs på
 * data-attribut, inga sektionsspecifika klassnamn – lägg inte tillbaka en kopia
 * i någondera sektionen.
 *   [data-wubs-toc]       förteckningens <nav>
 *   [data-wubs-toc-item]  en rad i förteckningen (får .is-active)
 *   [data-wubs-toc-det]   <details> som fälls ihop under 990 px
 *   [data-wubs-sticky]    sidokolumnen – följer sidan när den är högre än fönstret
 *
 * Två uppgifter, båda progressiv förbättring: förteckningen och dess ankarlänkar
 * fungerar utan den här filen (de renderas serverside i respektive sektion).
 *
 *  1. Mäter headerns höjd → --wubs-hh, som sidokolumnens sticky-offset och
 *     rubrikernas scroll-margin läser. Headern byter höjd mellan brytpunkter,
 *     så ett fast tal i CSS:en ger antingen glipa eller överlapp.
 *  2. Markerar vilken rubrik man läser just nu i förteckningen.
 *  3. Låter en sidokolumn som är högre än fönstret FÖLJA sidans scroll (se stallSticky).
 */
(function () {
  function headerHojd() {
    var h = document.querySelector('wubs-header') || document.querySelector('.wubs-header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }

  function sattHojd() {
    var hh = headerHojd();
    if (hh > 0) document.documentElement.style.setProperty('--wubs-hh', hh + 'px');
  }

  /* SIDOKOLUMNEN FÅR ALDRIG EGEN SCROLL (Liam 2026-09-13).
     Förut fick en kolumn som var högre än fönstret `max-height` + intern scroll – längst ned på
     sidan stod den stilla och resten av den gick bara att nå genom att scrolla INUTI den.

     Nu: ryms den i fönstret är den vanlig sticky (CSS:ens `top`). Ryms den inte tar skriptet över
     `top` och flyttar den med samma belopp som sidan scrollar, KLAMPAD mellan två lägen:
       max = headerns underkant + luft  → toppen syns (när man scrollar uppåt)
       min = fönsterhöjd − höjd − luft  → nederkanten syns (när man scrollar nedåt)
     Så följer kolumnen med sidan tills dess nederkant syns och står sedan still; scrollar man
     tillbaka följer den med tills toppen syns. Allt innehåll nås med sidans egen scroll.

     ⚠️ `top` räknas från headerns FAKTISKA underkant, inte från --wubs-hh: annonsraden glider
     bort vid scroll (wubs-header.js), och då flyttar sig headerns underkant.
     ⚠️ Sticky ger bara effekt så länge elementet sitter fast – när kolumnen ligger på sin
     naturliga plats (nära gridens topp eller botten) följer den sidan av sig själv, och det
     spelar ingen roll var `top` står. Därför räcker det att klampa, ingen lägesmaskin behövs. */
  var LUFT = 20;
  var sticky = null;
  var hog = false;
  var toppLage = 0;
  var forraY = 0;

  function headerUnderkant() {
    var h = document.querySelector('.wubs-header-section') || document.querySelector('wubs-header');
    return h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
  }

  function folj() {
    if (!hog) return;
    var y = window.scrollY;
    var dy = y - forraY;
    forraY = y;
    var max = headerUnderkant() + LUFT;
    var min = Math.min(max, window.innerHeight - sticky.offsetHeight - LUFT);
    toppLage = Math.min(max, Math.max(min, toppLage - dy));
    sticky.style.top = Math.round(toppLage) + 'px';
  }

  function stallSticky() {
    if (!sticky) return;
    // Under 990 px är kolumnen `display: contents` – ingen sticky att styra.
    var aktiv = getComputedStyle(sticky).position === 'sticky';
    var plats = window.innerHeight - headerUnderkant() - 2 * LUFT;
    // 40 px hysteres: annonsraden ändrar headerns höjd när den glider undan, och en kolumn på
    // gränsen hade annars växlat läge fram och tillbaka vid varje scroll.
    var ryms = hog ? sticky.offsetHeight <= plats - 40 : sticky.offsetHeight <= plats;
    if (!aktiv || ryms) {
      if (hog) {
        hog = false;
        sticky.classList.remove('is-hog');
        sticky.style.top = '';
      }
      return;
    }
    if (!hog) {
      hog = true;
      sticky.classList.add('is-hog');
      toppLage = sticky.getBoundingClientRect().top;
      forraY = window.scrollY;
    }
    folj();
  }

  /* Förteckningen renderas <details open> så den syns utan JS. Under 990 px fälls den
     ihop – där tar 12 rader 520 px och skjuter brödtexten under två skärmhöjder.
     ⚠️ Bara vid brytpunktsBYTE, aldrig vid varje resize: annars slås en förteckning
     som läsaren själv öppnat igen så fort mobilens adressfält ändrar fönsterhöjden. */
  var forraSmal = null;
  function stallToc() {
    var det = document.querySelector('[data-wubs-toc-det]');
    if (!det) return;
    var smal = window.matchMedia('(max-width: 989px)').matches;
    if (smal === forraSmal) return;
    forraSmal = smal;
    det.open = !smal;
  }

  function init() {
    sattHojd();
    stallToc();
    sticky = document.querySelector('[data-wubs-sticky]');
    stallSticky();
    window.addEventListener('resize', function () {
      sattHojd();
      stallToc();
      stallSticky();
    });
    if (sticky) {
      // Höjden ändras när förteckningen fälls ut, bilder laddas eller typsnittet byts.
      if (window.ResizeObserver) new ResizeObserver(stallSticky).observe(sticky);
      var efter = null;
      window.addEventListener(
        'scroll',
        function () {
          folj();
          // Annonsraden glider undan på 0,28 s EFTER scrollhändelsen – läs om headerns underkant
          // när den hunnit fram, annars står kolumnen kvar med en glipa under headern.
          clearTimeout(efter);
          efter = setTimeout(folj, 320);
        },
        { passive: true }
      );
    }

    var toc = document.querySelector('[data-wubs-toc]');
    if (!toc) return;

    var poster = [].slice.call(toc.querySelectorAll('[data-wubs-toc-item]'));
    var mal = poster
      .map(function (li) {
        var a = li.querySelector('a[href^="#"]');
        var el = a && document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
        return el ? { li: li, el: el } : null;
      })
      .filter(Boolean);
    if (!mal.length) return;

    var aktiv = null;

    /* Den lästa rubriken = den SISTA vars överkant passerat läslinjen (strax under
       headern). Ren geometri i stället för IntersectionObserver: med observer måste
       man välja ett band, och rubriker som ligger tätt hoppar då över varandra. */
    function uppdatera() {
      var linje = headerHojd() + 40;
      var vald = mal[0];
      for (var i = 0; i < mal.length; i++) {
        if (mal[i].el.getBoundingClientRect().top <= linje) vald = mal[i];
        else break;
      }
      /* Längst ned på sidan hinner sista rubriken aldrig passera linjen om artikeln
         slutar tätt efter den – markera den ändå, annars fastnar markören en post fel. */
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        vald = mal[mal.length - 1];
      }
      if (vald === aktiv) return;
      if (aktiv) aktiv.li.classList.remove('is-active');
      vald.li.classList.add('is-active');
      aktiv = vald;
    }

    var vantar = false;
    window.addEventListener(
      'scroll',
      function () {
        if (vantar) return;
        vantar = true;
        requestAnimationFrame(function () {
          vantar = false;
          uppdatera();
        });
      },
      { passive: true }
    );

    uppdatera();
    // Exponerad för verifiering: rAF är strypt i förhandsgranskningspanen.
    window.WubsTOC = { uppdatera: uppdatera, antal: mal.length, stallSticky: stallSticky, folj: folj };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
